import { useEffect } from 'react';
import style from './ConnectWallet.module.scss';
import { WalletConnectLoginButton, LedgerLoginButton, ExtensionLoginButton } from '@multiversx/sdk-dapp/UI';
import { useNavigate } from 'react-router-dom';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';

function ConnectWallet() {
    const navigate = useNavigate();
    const { account } = useGetAccountInfo();
    const isConnected = account && account.address;

    useEffect(() => {
        if (isConnected) {
            navigate('/rewards');
        }
    }, [isConnected, navigate]);

    return (
        <div className={style.connectWalletPage}>
            <div className="container">
                <h1>Connect Your Wallet</h1>
                <span>Choose one of the option below</span>
                <div className="options">
                    <WalletConnectLoginButton
                        callbackRoute="/rewards"
                        onLoginRedirect="/rewards"
                        buttonClassName="option"
                    >
                        <span>Mobile</span>
                        <img src="/assets/icons/x-portal-app.png" alt="xPortal App icon" />
                        <strong>xPortal App</strong>
                    </WalletConnectLoginButton>
                    <LedgerLoginButton
                        callbackRoute="/rewards"
                        onLoginRedirect="/rewards"
                        buttonClassName="option"
                    >
                        <span>Hardware</span>
                        <img src="/assets/icons/ledger.png" alt="Ledger icon" />
                        <strong>Ledger</strong>
                    </LedgerLoginButton>
                    <ExtensionLoginButton
                        callbackRoute="/rewards"
                        onLoginRedirect="/rewards"
                        buttonClassName="option"
                    >
                        <span>Extension</span>
                        <img src="/assets/icons/defi-wallet.png" alt="DeFi Wallet icon" />
                        <strong>DeFi Wallet</strong>
                    </ExtensionLoginButton>
                </div>
            </div>
        </div>
    );
}

export default ConnectWallet; 